module.exports = __webpack_public_path__ + "static/img/Bachelor_010855.53cc533.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010855.jpg
// module id = 263
// module chunks = 0